import React from "react";
import { categories, policies } from "../../data/wholesaleProducts";

export default function FooterBar({ shop, openPolicy, go }) {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="footer-brand">
          <button onClick={() => go("home")}>delmorian</button>
          <p>
            Care for growing families,
            <br />
            from first days onward.
          </p>
        </div>
        <aside className="footer-newsletter">
          <span>A LITTLE LETTER, ONCE A MONTH</span>
          <p>Thoughtful notes, new rituals and family care—sent gently.</p>
          <form onSubmit={(event) => event.preventDefault()}>
            <label className="sr-only" htmlFor="footer-email">
              Email address
            </label>
            <input
              id="footer-email"
              type="email"
              placeholder="YOUR EMAIL ADDRESS"
            />
            <button type="submit">
              JOIN <span aria-hidden="true">→</span>
            </button>
          </form>
        </aside>
      </div>
      <div className="footer-directory">
        <nav className="footer-shop" aria-label="Shop categories">
          <b>SHOP</b>
          <div>
            {categories.slice(1).map((category) => (
              <button onClick={() => shop(category)} key={category}>
                {category}
              </button>
            ))}
          </div>
        </nav>
        <nav className="footer-policies" aria-label="Policies">
          <b>
            GOOD TO KNOW <small>{Object.keys(policies).length} GUIDES</small>
          </b>
          <div className="footer-policy-links">
            {Object.keys(policies).map((key) => (
              <button onClick={() => openPolicy(key)} key={key}>
                {policies[key].nav}
              </button>
            ))}
          </div>
        </nav>
        <address className="footer-contact">
          <b>CONTACT</b>
          <div>
            <p>56 Commonwealth Dr, Singapore 141056</p>
          </div>
        </address>
      </div>
      <div className="footer-bottom">
        <span>MADE WITH TENDER INTENTION</span>
        <small>© 2026 DELMORIAN · ORIGINAL DEMONSTRATION STORE</small>
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          BACK TO TOP <span aria-hidden="true">↑</span>
        </button>
      </div>
    </footer>
  );
}
